/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryDetail
 */
export interface CountryDetail {
    /**
     * 
     * @type {number}
     * @memberof CountryDetail
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CountryDetail
     */
    numericCode: string;
    /**
     * 
     * @type {string}
     * @memberof CountryDetail
     */
    alpha3Code: string;
    /**
     * 
     * @type {string}
     * @memberof CountryDetail
     */
    alpha2Code: string;
    /**
     * 
     * @type {string}
     * @memberof CountryDetail
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CountryDetail
     */
    nameJa: string;
    /**
     * 
     * @type {string}
     * @memberof CountryDetail
     */
    subdivisionCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof CountryDetail
     */
    isGroupD: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CountryDetail
     */
    isGroupA: boolean;
}

export function CountryDetailFromJSON(json: any): CountryDetail {
    return CountryDetailFromJSONTyped(json, false);
}

export function CountryDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'numericCode': json['numericCode'],
        'alpha3Code': json['alpha3Code'],
        'alpha2Code': json['alpha2Code'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'subdivisionCode': json['subdivisionCode'],
        'isGroupD': json['isGroupD'],
        'isGroupA': json['isGroupA'],
    };
}

export function CountryDetailToJSON(value?: CountryDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'numericCode': value.numericCode,
        'alpha3Code': value.alpha3Code,
        'alpha2Code': value.alpha2Code,
        'name': value.name,
        'nameJa': value.nameJa,
        'subdivisionCode': value.subdivisionCode,
        'isGroupD': value.isGroupD,
        'isGroupA': value.isGroupA,
    };
}


